import { baseApi, TAG } from '../../app/api/baseApi'
const RESYNC_SETTLE_MS = 10000
const asArray = (data) => (Array.isArray(data) ? data : [])
const updatedTime = (range) => ({
    fromTime: range ? range.from : null,
    toTime: range ? range.to : null
})
const toRecord = (record) => ({
    messageId: record.messageId,
    entityName: record.entityName || '',
    sourceId: record.sourceId || '',
    targetId: record.targetId || '',
    reference: record.reference || '',
    statusName: record.statusName || '',
    errorMessage: record.errorMessage || '',
    updatedTime: record.updatedTime || null,
    syncCounter: typeof record.syncCounter === 'number' ? record.syncCounter : 0
})
export const syncReportsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getEntitySummary: builder.query({
            query: ({ instanceId, endpointId, requestType, range }) => ({
                url: '/Client/connections/report/summary',
                method: 'POST',
                body: {
                    subscriptionInstanceId: instanceId,
                    sourceEndpointId: endpointId,
                    requestType,
                    ...(range ? { updatedTime: updatedTime(range) } : {})
                }
            }),
            transformResponse: asArray,
            providesTags: [TAG.ENTITY_SUMMARY]
        }),
        getSyncTime: builder.query({
            query: ({ instanceId, endpointId, requestType }) => ({
                url: '/Client/connections/sync-time',
                method: 'POST',
                body: { subscriptionInstanceId: instanceId, sourceEndpointId: endpointId, requestType }
            }),
            transformResponse: (data) => ({
                lastPull: (data && data.lastPullTime) || null,
                lastPush: (data && data.lastPushTime) || null
            }),
            providesTags: [TAG.SYNC_TIME]
        }),
        getSyncRecords: builder.query({
            query: (args) => {
                const body = {
                    page: args.page,
                    pageSize: args.pageSize,
                    subscriptionInstanceId: args.instanceId,
                    sourceEndpointId: args.endpointId,
                    requestType: args.requestType,
                    statusIds: args.statusIds || [],
                    entityIds: args.entityIds || [],
                    updatedTime: updatedTime(args.range)
                }
                if (args.messageId) body.messageIds = [parseInt(args.messageId, 10)]
                if (args.sourceId) body.sourceId = args.sourceId
                if (args.targetId) body.targetId = args.targetId
                if (args.reference) body.reference = args.reference
                return { url: '/Client/connections/report/details', method: 'POST', body }
            },
            transformResponse: (data) => ({
                records: asArray(data && data.records).map(toRecord),
                totalRecords: data && typeof data.totalRecords === 'number' ? data.totalRecords : 0
            }),
            providesTags: [TAG.SYNC_RECORDS]
        }),
        resyncRecords: builder.mutation({
            query: ({ requestType, messageIds }) => ({
                url: '/Client/ManualSync',
                method: 'POST',
                body: { requestType, messageId: messageIds }
            }),
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    if (data && data.result) {
                        setTimeout(() => {
                            dispatch(baseApi.util.invalidateTags([TAG.SYNC_RECORDS, TAG.ENTITY_SUMMARY, TAG.SYNC_TIME]))
                        }, RESYNC_SETTLE_MS)
                    }
                } catch (error) {

                }
            }
        })
    })
})

export const {
    useGetEntitySummaryQuery,
    useGetSyncTimeQuery,
    useGetSyncRecordsQuery,
    useResyncRecordsMutation
} = syncReportsApi
const toCount = (value) => (typeof value === 'number' && value > 0 ? value : 0)

export const toEntityRow = (entity) => {
    const row = {
        entityId: entity.entityId,
        entityName: entity.entityName || '',
        requestReceived: toCount(entity.requestReceivedCount),
        inProcess: toCount(entity.inProcessCount),
        responseReceived: toCount(entity.responseReceivedCount),
        responseTransferred: toCount(entity.responseTransferredCount),
        error: toCount(entity.errorCount),
        completed: toCount(entity.completeCount),
        total: toCount(entity.totalCount)
    }
    row.inFlight = row.requestReceived + row.inProcess + row.responseReceived + row.responseTransferred
    return row
}
